/* unplugin-vue-components disabled */import { render } from "./UserCert.vue?vue&type=template&id=09173ff6&scoped=true"
import script from "./UserCert.vue?vue&type=script&lang=js"
export * from "./UserCert.vue?vue&type=script&lang=js"

import "./UserCert.vue?vue&type=style&index=0&id=09173ff6&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09173ff6"]])

export default __exports__